/**
 * 模块: AdvantageKeywordsTab
 * 职责: 优势关键词分析Tab组件
 * 限制: <280行
 */

import React from 'react';
import { Card, Table, Row, Col, Empty, Spin } from 'antd';
import type { AdvantageKeywordsResult } from '../../../types';
import {
  conversionAdvantageColumns,
  ctrAdvantageColumns,
  shareAdvantageColumns,
  priceAdvantageColumns,
} from './tableColumns';

interface AdvantageKeywordsTabProps {
  data: AdvantageKeywordsResult | null;
  loading: boolean;
}

export const AdvantageKeywordsTab: React.FC<AdvantageKeywordsTabProps> = ({
  data,
  loading,
}) => {
  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 50 }}>
        <Spin size="large" tip="加载优势关键词分析..." />
      </div>
    );
  }

  if (!data) {
    return <Empty description="暂无优势关键词数据" />;
  }

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Card title="🏆 转化率优势 TOP10" size="small">
            <Table
              dataSource={data.conversion_advantage || []}
              columns={conversionAdvantageColumns}
              pagination={false}
              size="small"
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="⚡ 点击率优势 TOP10" size="small">
            <Table
              dataSource={data.ctr_advantage || []}
              columns={ctrAdvantageColumns}
              pagination={false}
              size="small"
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col span={12}>
          <Card title="📊 占比优势 TOP10" size="small">
            <Table
              dataSource={data.share_advantage || []}
              columns={shareAdvantageColumns}
              pagination={false}
              size="small"
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="💰 价格优势 TOP10" size="small">
            <Table
              dataSource={data.price_advantage || []}
              columns={priceAdvantageColumns}
              pagination={false}
              size="small"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

